module.exports = __webpack_public_path__ + "img/boardWin.3d099fd4.jpg";